import { DealsComponent } from "@/features";
import { Deal } from "@/types";

interface Props {
  isLoading: boolean
  deals: Deal[]
  onRefresh?: () => void
  currentDeal: Deal | null
  onDealChange: (deal: Deal) => void
}

export const DealsPage = ({ deals, isLoading, onRefresh, currentDeal, onDealChange }: Props) => {
  return <DealsComponent deals={deals} isLoading={isLoading} onRefresh={onRefresh} currentDeal={currentDeal} onDealChange={onDealChange} />;
}
